import src from "IMAGE";
export default { src, width: 1180, height: 502, blurWidth: 0, blurHeight: 0};
